import * as React from 'react';
import styles from './App.module.sass';
import {HashRouter} from 'react-router-dom';
import {setI18nConfig} from './helperFunctions/translation';
import Layout from './components/Layout';
import Login from './screens/loginScreen';
import {inject, observer} from 'mobx-react';

@inject('authStore')
@observer
class App extends React.Component<any> {

    componentWillMount() {
        setI18nConfig();
        this.props.authStore.isAuthChanged();
    }

    render() {
        const {authStore} = this.props;
        return (
            <div className={styles.mainSection}>
                <HashRouter>
                    {
                        authStore.isAuthenticated === undefined ? null :
                            authStore.isAuthenticated ? <Layout/> :
                            <Login/>}
                </HashRouter>
            </div>
        );
    }
}

export default App;
